import makeStyles from "@mui/styles/makeStyles";
import colors from "../../../style/colors";

const useStyles = makeStyles({
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },
  radios: {
    textAlign: "center",
    marginBottom: 20,
  },
  radio: {
    display: "inline-block",
    position: "relative",
  },
  label: {
    display: "block",
    width: 100,
    position: "absolute",
    top: -8,
    left: "50%",
    marginLeft: -50,
    fontSize: 12,
    color: colors.light,
  },
  radioText: {
    fontSize: 12,
    color: colors.light,
    marginTop: -10,
  },
  scaleContainer: {
    display: "flex",
    width: "100%",
    color: "rgba(0, 0, 0, 0.9)",
    justifyContent: "space-between",
    marginTop: 20,
    marginBottom: 4,
    "@media (max-width: 767px)": {
      display: "flex",
      flexDirection: "column-reverse",
      margin: 0,
      width: "20%",
    },
  },
  scaleContainerSmall: {
    display: "flex",
    width: "100%",
    color: "rgba(0, 0, 0, 0.9)",
    justifyContent: "space-between",
    marginTop: 20,
    marginBottom: 4,
  },
  scaleBox: {
    width: 40,
    height: 40,
    borderLeft: "1px solid #8fa0b8",
    borderTop: "1px solid #8fa0b8",
    borderBottom: "1px solid #8fa0b8",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    cursor: "pointer",
    "&[isselected='true']": {
      backgroundColor: colors.primaryGreen,
    },
    "@media (max-width: 767px)": {
      width: 20,
      height: 20,
    },
  },
  endpointIndicatorContainer: {
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 767px)": {
      display: "flex",
      flexDirection: "column-reverse",
      justifyContent: "space-between",
    },
  },
  endpointIndicatorContainerSmall: {
    display: "flex",
    justifyContent: "space-between",
  },

  endpointIndicator: {
    width: 56,
    textAlign: "center",
    overflowWrap: "normal",
    "@media (max-width: 767px)": {
      marginBottom: 16,
    },
  },

  helperTextRow: {
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.54)",
    maxWidth: 700,
    marginTop: 10,
  },
  scaleWrapper: {
    width: "100%",
    "@media (max-width: 767px)": {
      display: "flex",
    },
  },
  scaleWrapperSmall: {
    width: "70%",
    margin: "0 auto",
    "@media (max-width: 767px)": {
      width: "100%",
    },
  },
  rangeCircle: {
    width: 51,
    height: 51,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "solid 0.8px rgba(4, 31, 65, 0.1)",
    borderRadius: "50%",
    textAlign: "center",
    cursor: "pointer",
    color: "#000",
    backgroundColor: "#fff",
    "&[isselected='true']": {
      border: (props) => `2px solid ${props.currentTheme.primaryColor}`,
      // backgroundColor: props => `${props.currentTheme.primaryColor}`,
      boxShadow: "0 10px 30px 0 rgba(0, 0, 0, 0.1)",
      color: (props) => `${props.currentTheme.primaryColor}`,
    },
    "@media (max-width: 767px)": {
      marginBottom: 16,
    },
    "@media (max-width: 1024px)": {
      width: 40,
      height: 40,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  radioBtn: {
    position: "absolute",
    width: "inherit",
    height: "inherit",
    opacity: "0",
    // zIndex: -1,
    "&:focus": {
      border: "none",
    },
  },
  offscreenText: {
    opacity: 0,
    position: "absolute",
  },
});

export default useStyles;
